<app-iota-modal i18n-title title="Import attributes" [modalOptions]="modalOptions" (close$)="close()">
    <div modal-body>
        <div *ngIf="currentStep === 1; then fileUpload"></div>
        <div *ngIf="currentStep === 2; then fileValidation"></div>
    </div>

    <div
        modal-footer
        class="flex flex-row justify-start items-center p-3 rounded-xl"
        [ngClass]="{ 'alert-error': errorMessage, 'alert-info': !!infoMessage }"
    >
        <div class="flex flex-row gap-5 items-center" *ngIf="errorMessage">
            <iota-icon icon="exclamation-triangle"> </iota-icon> <strong> {{ errorMessage }}</strong>
        </div>
        <div class="flex flex-row gap-5 items-center" *ngIf="!!infoMessage">
            <iota-icon icon="exclamation-triangle"> </iota-icon> <span> {{ infoMessage }}</span>
        </div>
        <div class="flex-1"></div>
        <div>
            <!-- Step 1 actions -->
            <div *ngIf="currentStep === 1">
                <button
                    class="btn btn-primary"
                    [disabled]="uploadedFile === null || uploadedFile === undefined"
                    (click)="confirmFileUpload()"
                    i18n
                >
                    Continue
                </button>
            </div>

            <!-- Step 2 actions -->
            <div *ngIf="currentStep === 2">
                <button class="btn btn-primary" [disabled]="errorMessage" (click)="confirmImport()" i18n>Confirm</button>
            </div>
        </div>
    </div>
</app-iota-modal>

<ng-template #fileUpload>
    <app-file-uploader
        class="flex flex-col justify-center items-center"
        multiple="false"
        (uploaded)="onFileUploaded($event)"
    ></app-file-uploader>
</ng-template>

<ng-template #fileValidation>
    <div class="flex flex-row items-center gap-2 mb-6">
        <label class="text-lg" i18n>Delete old attributes beforehand: </label>
        <input type="checkbox" class="toggle col-span-3" [(ngModel)]="deleteOldAttributes" [checked]="deleteOldAttributes" />
    </div>
    <table mat-table [dataSource]="newAttributesDataSource" class="w-full table table-compact ihag-mt-2 text-left">
        <ng-container matColumnDef="attributeName">
            <th mat-header-cell *matHeaderCellDef i18n>Name</th>
            <td mat-cell *matCellDef="let attribute">{{ attribute.attributeName }}</td>
        </ng-container>
        <ng-container matColumnDef="valueType">
            <th mat-header-cell *matHeaderCellDef i18n>Type</th>
            <td mat-cell *matCellDef="let attribute">{{ attribute.valueType }}</td>
        </ng-container>
        <ng-container matColumnDef="temporary">
            <th mat-header-cell *matHeaderCellDef i18n>Temporary</th>
            <td mat-cell *matCellDef="let attribute">{{ attribute.temporary }}</td>
        </ng-container>
        <ng-container matColumnDef="locale">
            <th mat-header-cell *matHeaderCellDef i18n>Language</th>
            <td mat-cell *matCellDef="let attribute">{{ attribute.locale }}</td>
        </ng-container>
        <ng-container matColumnDef="value">
            <th mat-header-cell *matHeaderCellDef i18n>Value</th>
            <td mat-cell *matCellDef="let attribute">{{ getValueDisplayString(attribute) }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="newAttributesColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: newAttributesColumns"></tr>
    </table>
</ng-template>
